import { Fade } from 'react-awesome-reveal';

const Description = () => {
  return (
    <Fade>
      <div className='center_wrapper'>
        <h2>Highlights</h2>
        <p className='highlight_description'>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tempore rem
          minima eos nulla mollitia! Magnam distinctio rem deleniti maiores
          impedit illum, eos dicta, ab, cum commodi aliquam similique corporis
          necessitatibus.
        </p>
      </div>
    </Fade>
  );
};

export default Description;
